import { createSlice } from '@reduxjs/toolkit';
import { mlkApi } from '../../apis/mlkApi/mlk.api';
import { AuthUser } from '../../models/auth.models';
import {
  setAccessTokenReducer,
  setAuthUserReducer,
  setIsEmailConfirmedReducer,
  setRefreshTokenReducer,
  setSignInSignUpDataReducer,
} from './user.reducer';

export interface UserState {
  authToken: string | null;
  refreshToken: string | null;
  authUser: AuthUser | null;
  isEmailConfirmed: boolean;
}

export const initialUserState: UserState = {
  authToken: null,
  refreshToken: null,
  authUser: null,
  isEmailConfirmed: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    setAccessToken: setAccessTokenReducer,
    setRefreshToken: setRefreshTokenReducer,
    setAuthUser: setAuthUserReducer,
    setIsEmailConfirmed: setIsEmailConfirmedReducer,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      mlkApi.endpoints.signIn.matchFulfilled,
      setSignInSignUpDataReducer
    );

    builder.addMatcher(
      mlkApi.endpoints.signUp.matchFulfilled,
      setSignInSignUpDataReducer
    );

    builder.addMatcher(
      mlkApi.endpoints.confirmEmail.matchFulfilled,
      setSignInSignUpDataReducer
    );

    builder.addMatcher(
      mlkApi.endpoints.googleSignIn.matchFulfilled,
      setSignInSignUpDataReducer
    );

    builder.addMatcher(
      mlkApi.endpoints.facebookSignIn.matchFulfilled,
      setSignInSignUpDataReducer
    );
  },
});

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;
